<template>
    <Modal  v-model="model.show" :title="model.title" @on-cancel="closeModel" footer-hide width="700">
        <div v-if="model.show">
            <router-view></router-view>
        </div>
    </Modal>
</template>

<script>
export default {
  name: "RouterModal",
  data: function() {
    return {
      reFresh: true,
      model: {
        show: false,
        title: ""
      }
    };
  },

  methods: {
    openModel: function(title, path) {
      this.model.show = true;
      this.model.title = title;
      this.$router.push(path);
    },
    closeModel: function() {
      this.model.show = false;
    }
  }
};
</script>
